import React from 'react';
import { MainWrapper } from 'src/domains/layouts/layouts/homepage/Homepage.style';
import { LayoutSkeleton } from 'src/domains/layouts/webview/modules/LayoutSkeleton';
import { PromotedEventsWidget } from 'src/domains/sportsbook/webview/components/containers/promotedEvents/PromotedEventsWidget';
import { observer } from 'src/utils/mobx-react';
import { PromotedEventsRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { SeoPagesContent } from 'src/domains/layouts/webview/components/seoPages/SeoPages';

interface PropsType {
    currentView: PromotedEventsRouteType;
    accountView: RightHandSideViewType | null;
    isSearchActive: boolean;
}

export const PromotedEvents = observer('PromotedEvents', ({ currentView, accountView, isSearchActive }: PropsType) => {
    return (
        <MainWrapper className='homepage'>
            <LayoutSkeleton
                currentView={currentView}
                accountView={accountView}
                isSearchActive={isSearchActive}
                navigationType='global'
            >
                <>
                    <PromotedEventsWidget topMargin={true} />
                    <SeoPagesContent pageSlug='promoted-events' />
                </>
            </LayoutSkeleton>
        </MainWrapper>
    );
});
